import { Pipe, PipeTransform } from '@angular/core';
import { formatNumber, kmToMiles } from '../../lib/utils';

@Pipe({ name: 'iftaOdometer' })
export class IftaOdometerPipe implements PipeTransform {
  public transform(odometer, metricUnits) {
    if (odometer == null || odometer === '') { return ''; }
    odometer = metricUnits ? odometer : kmToMiles(odometer);
    return formatNumber(odometer, 0);
  }
}
